import scrollMonitor from '../vendors/scrollMonitor';

export default function inView () {
    const el = document.querySelectorAll('[data-view]:not(.in-view)');

    function toggleClass (e) {
        if (this.isInViewport) {
            this.watchItem.classList.add('in-view', 'seen');
            this.destroy();
        }
    }

    function makeWatcher (element) {
        const watcher = scrollMonitor.create(
            element, {
                top: -50,
                bottom: 0
            }
        );

        watcher.stateChange(toggleClass);
        toggleClass.call(watcher);
        return watcher;
    }

    if (typeof (el) !== 'undefined' && el !== null) {
        for (let i = 0; i < el.length; i++) {
          const element = el[i];
          if (!element.watcher) {
            const watcher = makeWatcher(element);
            element.watcher = watcher;
          }
        }
    }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/viewport.js